import { get } from 'lodash'

export default function(fields = {}) {
  return {
    ...fields,
    organization: {
      ...fields.organization,
      acceptingOnlinePayment: undefined,
      alreadyRunningAward: undefined
    },
    note: get(fields, 'person.note'),
    person: {
      ...fields.person,
      address: {
        ...fields.person.address,
        deleted: undefined
      },
      deleted: undefined
    }
  }
}
